import MenuLink from "blocks/models/menu-link.interface";
import { CLOSE_ALL_OVERLAYS, OPEN_MEGA_DROPDOWN_MENU } from "layout/redux/overlay.actions";

let megaDropdownTimer: NodeJS.Timeout;

export default (event: any, item: MenuLink | undefined, dispatch: any) => {
    if (event) {
        event.stopPropagation();
    }

    if (megaDropdownTimer) {
        clearTimeout(megaDropdownTimer);
    }

    megaDropdownTimer = setTimeout(() => {
        if (item && item.content.subMenu && item.content.subMenu.length > 0) {
            dispatch({
                type: OPEN_MEGA_DROPDOWN_MENU,
                content: item,
            });
        } else {
            dispatch({
                type: CLOSE_ALL_OVERLAYS,
                content: undefined,
            });
        }
    }, 200);
};
